import { lazy } from 'react';
import { type Route, type Routes } from 'react-resource-router';
import { componentWithSuspense } from '../../utils';

const SimpleGraphExplorerPage = lazy(() => import('../../pages/simple-graph-explorer/home'));

const ROUTE_PREFIX = '/simple-graph-explorer' as const;

const simpleGraphExplorerRoutesObject: Record<string, Route> = {
	home: {
		name: 'simple-graph-explorer-home',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(SimpleGraphExplorerPage),
	},
};

export const simpleGraphExplorerRoutes: Routes = Object.values(simpleGraphExplorerRoutesObject);
